{
  "title": "Задачи",
  "newTask": "Новая задача",
  "addTask": "Добавить задачу",
  "kind": {
    "task": "Задача",
    "epic": "Эпик",
    "tasks": "Задачи",
    "noTasks": "Пока нет задач",
    "progress": "{{done}}/{{total}}",
    "journal": "Журнал этого ассета ведётся в {{key}}"
  },
  "empty": "Нет задач",
  "unnamed": "Без имени",
  "aiGenerated": "ИИ",
  "aiGeneratedHint": "Написано ИИ от лица этого пользователя",
  "allProjects": "Все проекты",
  "projectSearch": "Найти проект",
  "memberSearch": "Найти исполнителя",
  "epicSearch": "Найти эпик",
  "searchEmpty": "Ничего не найдено",
  "moveFailed": "Не удалось переместить задачу",
  "switcherAria": "Выбрать проект",
  "filter": {
    "label": "Фильтр задач",
    "all": "Все задачи",
    "roles": {
      "assignee": "Исполнитель",
      "author": "Автор"
    },
    "mine": {
      "assignee": "Мои задачи",
      "author": "Созданные мной"
    },
    "search": {
      "assignee": "Найти исполнителя",
      "author": "Найти автора"
    },
    "authoredBy": "Автор: {{name}}"
  },
  "overdue": "Срок прошёл",
  "columns": {
    "todo": "К выполнению",
    "in_progress": "В работе",
    "review": "На проверке",
    "done": "Готово"
  },
  "dialog": {
    "createTitle": "Новая задача",
    "title": "Название",
    "description": "Описание",
    "status": "Статус",
    "assignee": "Исполнитель",
    "noAssignee": "Без исполнителя",
    "agent": "Агент",
    "asset": "Ассет",
    "kind": "Тип",
    "epic": "Эпик",
    "noEpic": "Без эпика",
    "noAsset": "Без ассета",
    "assetLoadFailed": "Не удалось загрузить ассеты",
    "project": "Проект",
    "projectPlaceholder": "Выберите проект",
    "projectRequired": "Сначала выберите проект",
    "create": "Создать",
    "delete": "Удалить",
    "deleteTitle": "Удалить задачу?",
    "deleteMessage": "Задача «{{title}}» будет удалена без возможности восстановления.",
    "author": "Автор",
    "createdAt": "Создано",
    "editedAt": "изменено {{time}}, {{name}}",
    "saveFailed": "Не удалось сохранить задачу",
    "deleteFailed": "Не удалось удалить задачу",
    "loadFailed": "Не удалось загрузить задачу",
    "notFound": "Задача не найдена: её удалили или сменили префикс проекта",
    "titlePlaceholder": "Название задачи",
    "descriptionPlaceholder": "Добавьте описание…",
    "noDescription": "Нет описания",
    "dueDate": "Срок",
    "noDueDate": "Без срока",
    "clearDueDate": "Убрать срок",
    "actions": "Действия",
    "copyLink": "Скопировать ссылку",
    "linkCopied": "Ссылка скопирована",
    "copyFailed": "Не удалось скопировать ссылку",
    "addDescription": "Добавить описание",
    "editDescription": "Изменить описание",
    "saveDescription": "Сохранить",
    "cancelEdit": "Отмена",
    "unsavedTitle": "Выйти без сохранения?",
    "unsavedMessage": "Изменения в описании не будут сохранены.",
    "discard": "Выйти без сохранения",
    "overwrote": "Пока вы редактировали, описание изменил {{name}} — его вариант в истории",
    "overwroteSelf": "Пока вы редактировали, описание сохранили в другом окне — прежний вариант в истории",
    "pagerPosition": "{{index}} из {{total}}",
    "pagerPrev": "Предыдущая задача",
    "pagerNext": "Следующая задача"
  },
  "assetPick": {
    "character": "Эпик для героя",
    "location": "Эпик для локации",
    "prop": "Эпик для реквизита",
    "shot": "Эпик для шота",
    "script": "Эпик для сценария",
    "label": "Эпик",
    "new": "Создать новый",
    "continue": "Дальше"
  },
  "asset": {
    "loading": "Загружаем…",
    "search": {
      "character": "Найти героя",
      "location": "Найти локацию",
      "prop": "Найти реквизит"
    },
    "empty": {
      "character": "В проекте пока нет героев",
      "location": "В проекте пока нет локаций",
      "prop": "В проекте пока нет реквизита"
    }
  },
  "assetKind": {
    "none": "Без ассета",
    "character": "Герой",
    "location": "Локация",
    "prop": "Реквизит",
    "shot": "Шот",
    "script": "Сценарий"
  },
  "agent": {
    "shotMissing": "выберите шот",
    "shotSearch": "Найти шот",
    "shotsLoading": "Загружаем шоты…",
    "shotsLoadFailed": "Не удалось загрузить шоты",
    "noShots": "В проекте пока нет шотов",
    "episode": "Серия {{label}}",
    "scene": "Сцена {{label}}",
    "shot": "Шот {{label}}"
  },
  "delegation": {
    "button": "Передать агенту",
    "hintShot": "Выберите шот для ассистента шота",
    "hintDescription": "Сначала сохраните описание",
    "title": "Передать агенту · {{key}}",
    "description": "{{agent}} получит этот промпт от вашего имени. Его подготовил ассистент задач — проверьте и при необходимости поправьте.",
    "preparing": "Ассистент задач готовит промпт…",
    "prepareFailed": "Не удалось подготовить промпт",
    "retry": "Повторить",
    "fallback": "Итоги обсуждения не удалось свести автоматически — в промпт попали сами комментарии, сначала руководства. Проверьте их перед отправкой.",
    "promptLabel": "Промпт для агента",
    "send": "Отправить",
    "sent": "Задача передана: {{agent}}",
    "alreadySent": "Этот промпт уже отправлен",
    "failed": "Не удалось передать задачу"
  },
  "editor": {
    "toolbar": "Форматирование",
    "bold": "Жирный",
    "italic": "Курсив",
    "strike": "Зачёркнутый",
    "code": "Код",
    "heading": "Заголовок",
    "bulletList": "Список",
    "orderedList": "Нумерованный список",
    "quote": "Цитата",
    "table": "Таблица",
    "addRow": "Добавить строку",
    "addColumn": "Добавить столбец",
    "deleteRow": "Удалить строку",
    "deleteColumn": "Удалить столбец",
    "deleteTable": "Удалить таблицу"
  },
  "files": {
    "title": "Файлы",
    "library": "Библиотека",
    "fromComputer": "Загрузить файл",
    "fromLibrary": "Из Библиотеки",
    "attach": "Прикрепить",
    "open": "Открыть",
    "remove": "Удалить",
    "removeTitle": "Удалить файл?",
    "removeMessage": "Файл «{{name}}» будет удалён из задачи.",
    "removeMentioned": "Файл «{{name}}» упоминается в описании. Он будет удалён из задачи, а ссылка на него перестанет работать.",
    "removeMentionedInComments": "Файл «{{name}}» упоминается в комментариях. Он будет удалён из задачи, а ссылка на него перестанет работать.",
    "uploadFailed": "Не удалось загрузить файл",
    "removeFailed": "Не удалось удалить файл",
    "libraryPartial": "Не удалось прикрепить: {{names}}",
    "uploading": "Загрузка…",
    "waitUploads": "Дождитесь загрузки файлов",
    "dropHint": "Перетащите файлы или нажмите, чтобы выбрать",
    "dropOverlay": "Отпустите, чтобы прикрепить к задаче {{key}}",
    "dropOverlayNew": "Отпустите, чтобы прикрепить к новой задаче",
    "folderSkipped": "Папку прикрепить нельзя — перетащите сами файлы"
  },
  "draft": {
    "projectLocked": "Чтобы сменить проект, уберите: {{reasons}}",
    "lockLibraryFiles": "файлы из Библиотеки",
    "lockPeople": "упоминания людей",
    "lockEntities": "упоминания героев, локаций и реквизита",
    "lockShot": "шот ассистента шота",
    "saveTitle": "Сохранить черновик?",
    "saveMessage": "Название, описание и файлы останутся в черновике, и форма откроется с ними в следующий раз.",
    "save": "Сохранить",
    "delete": "Удалить",
    "saveFailed": "Не удалось сохранить черновик",
    "deleteFailed": "Не удалось удалить черновик",
    "tooManyFiles": "В черновике не больше {{max}} файлов",
    "uploadsTooLarge": "Файлы с компьютера в черновике — не больше {{max_mb}} МБ в сумме",
    "removeMessage": "Файл «{{name}}» будет удалён из черновика.",
    "removeMentioned": "Файл «{{name}}» упоминается в описании. Он будет удалён из черновика, а ссылка на него перестанет работать."
  },
  "comments": {
    "title": "Комментарии",
    "placeholder": "Оставьте комментарий…",
    "send": "Отправить",
    "attach": "Прикрепить файл",
    "edited": "изменено",
    "edit": "Изменить",
    "save": "Сохранить",
    "delete": "Удалить",
    "deleteTitle": "Удалить комментарий?",
    "deleteMessage": "Комментарий будет удалён без возможности восстановления.",
    "loadFailed": "Не удалось загрузить комментарии",
    "sendFailed": "Не удалось отправить комментарий",
    "saveFailed": "Не удалось сохранить комментарий",
    "deleteFailed": "Не удалось удалить комментарий",
    "loadingOlder": "Загружаем ранние комментарии…"
  },
  "history": {
    "title": "История описания",
    "versions": "Версии описания",
    "current": "Текущая",
    "showChanges": "Показывать изменения",
    "restore": "Восстановить эту версию",
    "empty": "Описание пустое",
    "loading": "Загрузка…",
    "loadFailed": "Не удалось загрузить историю описания",
    "restoreFailed": "Не удалось восстановить версию",
    "tooLargeForDiff": "Версии слишком длинные, чтобы подсветить изменения"
  },
  "board": {
    "loadingMore": "Загружаем задачи…",
    "loadFailed": "Не удалось загрузить задачи",
    "search": {
      "placeholder": "Поиск задач",
      "hint": "Ищет по тикеру, названию и описанию",
      "tooShort": "Введите хотя бы два символа или номер задачи",
      "clear": "Очистить поиск"
    }
  },
  "mentions": {
    "taskNoAccess": "нет доступа",
    "taskDeleted": "задача удалена",
    "taskSearchHint": "Введите 3 символа, чтобы найти задачу",
    "taskSearching": "Ищем задачи…",
    "openPerson": "Открыть в «Команде»",
    "openTask": "Открыть задачу",
    "heroDeleted": "герой удалён",
    "locDeleted": "локация удалена",
    "propDeleted": "реквизит удалён",
    "outfitDeleted": "образ удалён",
    "variantDeleted": "вариант удалён",
    "stateDeleted": "состояние удалено",
    "openHero": "Открыть в «Героях»",
    "openLoc": "Открыть в «Локациях»",
    "openProp": "Открыть в «Реквизите»",
    "shotDeleted": "шот удалён",
    "scriptDeleted": "сценарий удалён",
    "openShot": "Открыть шот в раскадровке",
    "openScript": "Открыть сценарий"
  },
  "reviewBlock": {
    "title": {
      "storyboard": "Задача из проверки кадра",
      "video": "Задача из проверки видео",
      "asset": "Задача из проверки ассета"
    },
    "states": {
      "draft": "черновик",
      "generated": "сгенерирован",
      "in_review": "ждёт проверки",
      "approved": "принят",
      "needs_changes": "нужны правки",
      "locked": "зафиксирован",
      "failed": "ошибка генерации"
    },
    "review": "Проверить"
  }
}
